import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import classNames from 'classnames/bind';
import ErrorBoundary from '../../atoms/ErrorBoundary';
import Layout from '../../../components/desktop/Layout';
import EventsAndWinnersPage from './components/mobile/EventsAndWinnersPage';
import EventLayoutPage from './components/mobile/EventLayoutPage';
import GrandPrize from './components/mobile/GrandPrize';
import { getQueryParams } from '../../utils/queryParams';
import { getDeviceType } from '../../../games/utils/gamePageUtilities';
import setupTopShopperNavigator from './utils/topShopperNavigator';
import { getAppWebViewStatus } from '../../selectors/topShopperPageSelectors';
import styles from './desktopTopShopper.pcss';

const cx = classNames.bind(styles);

interface DesktopTopShopperPage {
  location: Record<string, unknown>;
  appWebViewStatus: boolean;
  ErrorBoundary: FC;
}

const mapStateToProps = (state: any) => {
  return {
    appWebViewStatus: getAppWebViewStatus(state)
  };
};

const connector = connect(mapStateToProps);

const DesktopTopShopperPage = (props: DesktopTopShopperPage): JSX.Element => {
  const { location = {}, appWebViewStatus = false } = props;
  const { location: { href: pageUrl = '' } = {} } = window || {};
  const isAppsFlag = appWebViewStatus;
  const platform = useMemo(() => getDeviceType(isAppsFlag, 'website'), [isAppsFlag]);
  const eventName = useMemo(() => getQueryParams('event', pageUrl), [pageUrl]);
  const grandEvent = useMemo(() => getQueryParams('grandEvent', pageUrl), [pageUrl]);
  const redirectPage = useMemo(() => setupTopShopperNavigator(platform, eventName, grandEvent), [
    platform,
    eventName,
    grandEvent
  ]);
  const onGoBack = () => {
    window && window.history.back();
  };

  return (
    <ErrorBoundary>
      <Layout isFooter header footerSeo>
        <div className={cx('DesktopWarapperTopShopper')}>
          <Switch>
            <Route
              path="/top-shopper/events-and-winners"
              render={() => (
                <EventsAndWinnersPage
                  {...props}
                  platform={platform}
                  redirectPage={redirectPage}
                  onGoBack={onGoBack}
                />
              )}
            />
            <Route
              path="/top-shopper/grand-prize"
              render={() => (
                <GrandPrize
                  {...props}
                  platform={platform}
                  redirectPage={redirectPage}
                  onGoBack={onGoBack}
                />
              )}
            />
            <Route
              path="/top-shopper"
              render={() => (
                <EventLayoutPage {...props} platform={platform} redirectPage={redirectPage} />
              )}
            />
          </Switch>
        </div>
      </Layout>
    </ErrorBoundary>
  );
};

DesktopTopShopperPage.defaultProps = {};

export default connector(DesktopTopShopperPage);
